import Window from '../Window';
import styles from './DevTools.module.scss';
import settingsSvg from './assets/settings.svg';
import React, { useState } from 'react';

const DevTools = () => {
  const [windows, setWindows] = useState([]);

  const reOrder = (uuid) => {
    setWindows((w) => {
      const newW = w.filter((i) => i !== uuid);

      return [...newW, uuid];
    });
  };

  return (
    <>
      {windows.map((uuid, zIndex) => (
        <Window
          key={uuid}
          uuid={uuid}
          zIndex={zIndex}
          reOrder={reOrder}
          onClose={() => {
            setWindows((w) => w.filter((i) => i !== uuid));
          }}
        />
      ))}

      <div
        className={styles.open}
        onClick={() => {
          setWindows((w) => {
            const newKey = w.reduce((acc, v) => Math.max(acc, v), 0) + 1;

            return [...w, newKey];
          });
        }}
      >
        <img src={settingsSvg} alt="Open new settings" />
      </div>
    </>
  );
};

export default DevTools;
